<template>
  <div class="w-100 h-58px bo_b-1px bo-EDEDED_50 d-fx ai-c">
    <div class="w-100 h-31px d-fx">
      <!-- blue circle -->
      <div class="ml-15px"> 
        <span class="w-4px h-4px bor-100 mt-8px" :class="'b-'+this.colors.first"></span>
      </div>
      <!-- Image Icon -->
      <div class="ml-9px cursor-pointer">
        <img src="https://userist-server.s3.amazonaws.com/media/lion_king.jpg" alt="" class="w-20px h-20px bor-100">
      </div>
      <!-- Notification type -->
      <div class="ml-6px">
        <div class="d-fx ai-c">
          <span class="f-12px fw-500 lh-14px cursor-pointer" :class="'c-'+ this.colors.second">Comment</span>
          <div class="w-1px h-10px b-EDEDED ml-6px mr-6px"></div>
          <span class="f-12px fw-300 lh-14px c-999999 cursor-pointer">1h</span>
        </div>
        <div>
          <span class="f-12px fw-300 lh-14px cursor-pointer" :class="'c-'+this.colors.third">So interesting! Thanks for sharing :)</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import colors from '@/mixins/site_dependent/colors'

export default {
  name: 'NotificationC',
  extends: {},
  props: {},
  data(){
    return{};
  },
  components: {},
  computed: {},
  watch: {},
  methods: {},
  beforeCreate(){},
  mounted(){},
  mixins: [colors]
}
</script>
